<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <section class="account" v-if="!loading">
      <!-- {{udpdateHeader('account')}} -->

      <!-- tutorial - howitworks -->
      <div class="mx-5">
        <div class="row d-flex justify-content-end">
          <!-- <div class="col-md-6 d-flex align-items-center">
                <img
                  :src="dataUser.user.avatar ? dataUser.user.avatar : imageUser"
                  alt=""
                  class="rounded-circle border border-primary border-4 p-1"
                  width="150px"
                />
      
                <div class="text-left">
                  <p>
                    <strong>
                      {{ $t("lang.label.userid") }} :
                      <span>{{ dataUser.user.id }}</span>
                    </strong>
                  </p>
                  <h4 class="mt-3">
                    {{ dataUser.user.name + " " + dataUser.user.lastname }}
                  </h4>
                </div>
            </div> -->

          <div class="col-md-6">
            <div v-if="!isBdrUser">
              <div class="px-4 pb-2 pt-4" v-if="permissionFront()">
                <div class="row">
                  <div class="px-3 w-100">
                    <div clas="row pb-3">
                      <h5 class="mb-4 d-inline">
                        {{ $t("lang.credits.creditusage") }}
                      </h5>
                      <div class="float-right">
                        <Tutorial
                          id="smtpimap"
                          :linkText="$t('lang.label.howitworks')"
                          linkClass="small ml-2 mt-2"
                          :videoUrl="
                            'https://www.youtube.com/embed/' +
                            $t('lang.videos.credits')
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-block">
                  <div class="float-left mt-3">
                    <small v-if="toastNotificationData.credits.from"
                      >{{
                        $t("lang.credits.fromto", {
                          from: toastNotificationData.credits.from,
                          to: toastNotificationData.credits.to,
                        })
                      }}
                    </small>
                  </div>

                  <div class="float-right mt-3">
                    <small v-if="toastNotificationData.credits.attempts">
                      {{
                        $t("lang.credits.using", {
                          using: toastNotificationData.credits.attempts,
                          of: toastNotificationData.credits.total,
                        })
                      }}
                      <router-link
                        class="btn btn-primary themed-button btn-sm ml-2 ml-2"
                        to="/upgrade"
                      >
                        {{ $t("lang.button.upgrade") }}
                      </router-link>
                    </small>

                    <small v-else>
                      {{
                        $t("lang.credits.using", {
                          using: "0",
                          of: toastNotificationData.credits.total,
                        })
                      }}
                    </small>
                  </div>

                  <div class="float-left my-2 w-100">
                    <div class="content-bar">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          v-bind:style="{ width: calculatePercentage() + '%' }"
                          role="progressbar"
                          aria-valuenow="calculatePercentage()"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="card bg-primary p-2 w-100 text-white mt-1"
          v-if="hasPermissions('adminClients') && dataUser.client"
        >
          <h6>{{ $t("lang.accountcreation.shareurl") }}</h6>
          <strong
            ><i class="icon-copy"></i>
            https://app.oliverlist.com/createaccount/{{ dataUser.client.name
            }}{{ dataUser.client.id }}</strong
          >
        </div>

        <!-- parameters + bank account -->
        <div class="row">
          <!-- PARAMETROS GENERALES -->
          <div class="col-md-6 mt-3 p-0">
            <div class="card p-4">
              <div class="col-md-6 d-flex align-items-center">
                <span
                  v-if="
                    this.dataUser.user.avatar == null ||
                    this.dataUser.user.avatar == '' ||
                    this.dataUser.user.avatar == undefined
                  "
                >
                  <img
                    src="@/assets/images/emptyperson.png"
                    alt="example_png"
                    class="rounded-circle"
                    width="150px"
                  />
                </span>
                <span v-else>
                  <img
                    :src="this.dataUser.user.avatar"
                    alt="example_png"
                    class="rounded-circle border border-primary border-4 p-1"
                    width="150px"
                  />
                </span>

                <div class="text-left ml-2">
                  <p>
                    <strong>
                      {{ $t("lang.label.userid") }} :
                      <span>{{ dataUser.user.id }}</span>
                    </strong>
                  </p>
                  <h4 v-if="user.role_id == 1" class="mt-3">
                    {{ dataUser.user.name }}
                  </h4>
                  <h4 v-else class="mt-3">
                    {{ dataUser.user.name + " " + dataUser.user.lastname }}
                  </h4>
                </div>
              </div>

              <div class="title px-4 pb-2 pt-4">
                <div class="d-flex">
                  <div>
                    <h4 class="text-center">{{ $t("lang.label.general") }}</h4>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="YourName" class="col-form-label">{{
                  $t("lang.label.firstname")
                }}</label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourName') == true"
                    id="YourName"
                    v-model="dataUser.user.name"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="LastName" class="col-form-label">{{
                  $t("lang.label.lastname")
                }}</label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourLastName') == true"
                    id="YourLastName"
                    v-model="dataUser.user.lastname"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="YourEmail" class="col-form-label">{{
                  $t("lang.label.email")
                }}</label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourEmail') == true"
                    id="YourEmail"
                    v-model="dataUser.user.email"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="YourEmail" class="col-form-label">{{
                  $t("lang.label.language")
                }}</label>
                <div>
                  <select
                    v-model="dataUser.user.language_id"
                    class="form-control"
                  >
                    <option
                      v-for="(lang, i) in langs"
                      :key="`Lang${i}`"
                      :value="lang.id"
                    >
                      {{ lang.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- <div class="form-group" v-if="isBdrUser">
                <label for="YourEmail" class="col-form-label">
                  {{ $t("lang.label.language_spoken") }}
                </label>
                <treeselect
                  v-model="dataUser.user.spoken_language_ids"
                  :options="spokenLangs"
                  :multiple="true"
                >
                </treeselect>
              </div> -->

              <div
                class="form-group"
                v-if="user.role_id != 3 && user.role_id != 4"
              >
                <label for="YourEmail" class="col-form-label">{{
                  $t("lang.label.phone")
                }}</label>
                <div>
                  <input
                    type="number"
                    class="form-control"
                    :disabled="rolCampo('phone') == true"
                    id="YourEmail"
                    v-model="dataUser.user.phone"
                  />
                </div>
              </div>

              <div
                class="form-group"
                v-if="user.role_id != 3 && user.role_id != 4"
              >
                <label for="YourEmail" class="col-form-label">
                  Ringover phone
                </label>
                <div>
                  <input
                    type="number"
                    class="form-control"
                    :disabled="true"
                    v-model="dataUser.user.ringover_phone"
                  />
                </div>
              </div>
            </div>
            <!-- password -->
            <div class="col-md-12 p-0 mt-2">
              <ChangePassword v-if="user.role_id > 1" />
            </div>
          </div>

          <!-- BANK ACCOUNT -->
          <div class="col-md-6 mt-3" v-if="dataUser.user.bank_data">
            <div class="card p-4">
              <div class="title px-4 pb-2 pt-4">
                <div class="d-flex">
                  <div>
                    <h4 class="text-center">
                      {{ $t("lang.column.bank_details") }}
                    </h4>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="YourName" class="col-form-label">
                  {{ $t("lang.column.name_to_bank") }}
                </label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourName') == true"
                    id="YourName"
                    v-model="dataUser.user.bank_data.account_holder_name"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="YourName" class="col-form-label">
                  {{ $t("lang.column.date_birth") }}
                </label>
                <div>
                  <date-picker id="birthDatePicker" class="" v-model="dataUser.user.date_of_birth" :config="datePickerConfig"
                  placeholder="Birth Date"></date-picker>
                </div>
              </div>

              <div class="form-group">
                <label for="YourName" class="col-form-label"> RIB </label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourName') == true"
                    id="YourName"
                    v-model="dataUser.user.bank_data.rib"
                    maxlength="34"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="YourName" class="col-form-label"> BIC </label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourName') == true"
                    id="YourName"
                    v-model="dataUser.user.bank_data.bic"
                    maxlength="11"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="YourName" class="col-form-label">
                  {{ $t("lang.column.address") }}
                </label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourName') == true"
                    id="YourName"
                    v-model="dataUser.user.bank_data.address"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="YourName" class="col-form-label">
                  {{ $t("lang.label.postalcode") }}
                </label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourName') == true"
                    id="YourName"
                    v-model="dataUser.user.bank_data.postal_code"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="YourName" class="col-form-label">
                  {{ $t("lang.column.city") }}
                </label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="rolCampo('YourName') == true"
                    id="YourName"
                    v-model="dataUser.user.bank_data.city"
                  />
                </div>
              </div>
            </div>

            <!-- design en vista booker -->
            <div class="col-md-12 my-2 p-0" v-if="isBdrUser">
              <div class="card p-3">
                <div class="title px-4 pb-2 pt-4">
                  <div class="d-flex">
                    <div>
                      <h4>{{ $t("lang.label.design_profile") }}</h4>
                    </div>
                  </div>
                </div>
                <div class="body p-3">
                  <div class="row mt-5">
                    <div class="col-md-6">
                      <div class="form-group">
                        <h6
                          class="font-weight-bold pb-2 text-center"
                          v-if="!isBdrUser"
                        >
                          {{
                            $t(
                              "lang.label.personalizethesignatureofprospectingemails"
                            )
                          }}
                        </h6>
                      </div>
                      <div class="form-group">
                        <small class="text-center" v-if="!isBdrUser">{{
                          $t("lang.preparingapp.logo")
                        }}</small>
                        <div class="text-center">
                          <div>
                            <button
                              class="btn cursor-pointer btn btn-success mt-4"
                            >
                              <a
                                :class="{
                                  disabled:
                                    !hasPermissions('billing') &&
                                    !isBdrUser &&
                                    this.$store.state.authentication.user
                                      .user_constraint_id != 2,
                                }"
                                @click="toggleShow"
                                >{{ $t("lang.label.change_image_profile") }}</a
                              >
                            </button>
                            <uploadImage
                              field="img"
                              @crop-success="cropSuccess"
                              @crop-upload-success="cropUploadSuccess"
                              @crop-upload-fail="cropUploadFail"
                              v-model="show"
                              :width="300"
                              :height="300"
                              :params="params"
                              :headers="headers"
                              lang-type="en"
                              img-format="png"
                            >
                            </uploadImage>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <ValidationProvider
                        class="form-group"
                        ref="colorPickerV"
                        :rules="colorRules"
                      >
                        <div slot-scope="{ errors }">
                          <div
                            class="form-group valid featured required field-input field-ckeditor text-center bg-light p-4 rounded shadow-sm"
                            :class="errors.length > 0 ? 'error' : ''"
                          >
                            <h5 class="font-weight-bold">
                              {{ $t("lang.label.favourite_color") }}
                            </h5>
                            <div style="position: relative; margin-right: 20px">
                              <div class="d-flex justify-content-center">
                                <button
                                  class="btn btn-success ml-4"
                                  @click="openColorPicker"
                                >
                                  {{ $t("lang.label.change_color") }}
                                </button>
                              </div>
                              <div
                                style="
                                  position: absolute;
                                  top: 45px;
                                  right: 20px;
                                "
                              >
                                <color-picker
                                  v-model="hex_color"
                                  :width="100"
                                  :height="100"
                                  v-if="showColorPicker"
                                ></color-picker>
                              </div>
                            </div>

                            <div class="errors help-block">
                              <span>{{ errors[0] }}</span>
                            </div>
                          </div>
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Nueva fila para colocar los dos divs en línea -->
          <div class="col-md-6 w-100">
            <!-- Firma y ejemplo ilustrativo -->
            <div class="col-md-12 card p-2 my-3 template-msg" v-if="!isBdrUser">
              <div>
                <i class="fas fa-info-circle mr-2 text-secondary"></i>
                {{ $t("lang.preparingapp.signatureexample") }}
              </div>
              <div class="py-3 px-3 bg-lg text-center">
                <div class="w-100 px-2">
                  <br />
                  <span :style="'color:' + hex_color">
                    <b>John Doe</b>
                    <!--<b>{{ dataUser.user.name + " " + dataUser.user.lastname }}</b> -->
                  </span>
                  <br />
                  Business Developer
                  <br />
                  Sales Department |
                  <span v-if="dataUser.client">{{
                    dataUser.client.company_name
                  }}</span>
                  <br />
                  <br />
                  <img
                    :src="this.dataUser.user.avatar"
                    alt=""
                    class="rounded border-color mr-4"
                    width="100px"
                  />
                </div>
              </div>
            </div>

            <!-- Enterprise Information -->
            <div class="col-md-12 p-0" v-if="dataUser.client && !isBdrUser">
              <div class="card p-4">
                <div class="mt-3 mr-4">
                  <h4 class="font-weight-bold text-center">
                    {{ dataUser.client.name }}
                  </h4>
                </div>
                <div>
                  <div class="d-flex justify-content-center">
                    <h6 class="font-weight">
                      {{ $t("lang.label.general") }}
                    </h6>
                    <p class="mx-4">
                      {{ $t("lang.label.companyid") }} :
                      <span>{{ dataUser.client.id }}</span>
                    </p>
                  </div>
                  <div class="form-group">
                    <label for="CompanyName" class="col-form-label">{{
                      $t("lang.label.companyname")
                    }}</label>
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        :disabled="rolCampo('CompanyName') == true"
                        id="CompanyName"
                        v-model="dataUser.client.name"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="CompanyName" class="col-form-label">
                      {{ $t("lang.label.company_name_used") }}
                    </label>
                    <div>
                      <input
                        type="text"
                        maxlength="45"
                        class="form-control"
                        :disabled="rolCampo('CompanyNameUsed') == true"
                        id="CompanyNameUsed"
                        v-model="dataUser.client.company_name"
                        :class="{ 'is-invalid': invalidInput }"
                      />
                      <div v-if="invalidInput" class="text-danger">
                        {{ $t("lang.label.company_name_invalid") }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="CompanyEmail" class="col-form-label">{{
                      $t("lang.label.companyemail")
                    }}</label>
                    <div class="">
                      <input
                        type="text"
                        class="form-control"
                        :disabled="rolCampo('CompanyEmail') == true"
                        id="CompanyEmail"
                        v-model="dataUser.client.email"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- design en vistas billing - admin - agency -->
            <div class="col-md-12 my-2 p-0" v-if="!isBdrUser">
              <div class="card p-3">
                <div class="title px-4 pb-2 pt-4">
                  <div class="d-flex">
                    <div>
                      <h4>{{ $t("lang.label.design_profile") }}</h4>
                    </div>
                  </div>
                </div>
                <div class="body p-3">
                  <div class="row mt-5">
                    <div class="col-md-6">
                      <div class="form-group">
                        <h6
                          class="font-weight-bold pb-2 text-center"
                          v-if="!isBdrUser"
                        >
                          {{
                            $t(
                              "lang.label.personalizethesignatureofprospectingemails"
                            )
                          }}
                        </h6>
                      </div>
                      <div class="form-group">
                        <small class="text-center" v-if="!isBdrUser">{{
                          $t("lang.preparingapp.logo")
                        }}</small>
                        <div class="text-center">
                          <div>
                            <button
                              class="btn cursor-pointer btn btn-success mt-4"
                            >
                              <a
                                :class="{
                                  disabled:
                                    !hasPermissions('billing') &&
                                    !isBdrUser &&
                                    this.$store.state.authentication.user
                                      .user_constraint_id != 2,
                                }"
                                @click="toggleShow"
                                >{{ $t("lang.label.change_image_profile") }}</a
                              >
                            </button>
                            <uploadImage
                              field="img"
                              @crop-success="cropSuccess"
                              @crop-upload-success="cropUploadSuccess"
                              @crop-upload-fail="cropUploadFail"
                              v-model="show"
                              :width="300"
                              :height="300"
                              :params="params"
                              :headers="headers"
                              lang-type="en"
                              img-format="png"
                            >
                            </uploadImage>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <ValidationProvider
                        class="form-group"
                        ref="colorPickerV"
                        :rules="colorRules"
                      >
                        <div slot-scope="{ errors }">
                          <div
                            class="form-group valid featured required field-input field-ckeditor text-center bg-light p-4 rounded shadow-sm"
                            :class="errors.length > 0 ? 'error' : ''"
                          >
                            <h5 class="font-weight-bold">
                              {{ $t("lang.label.favourite_color") }}
                            </h5>
                            <div style="position: relative; margin-right: 20px">
                              <div class="d-flex justify-content-center">
                                <button
                                  class="btn btn-success ml-4"
                                  @click="openColorPicker"
                                >
                                  {{ $t("lang.label.change_color") }}
                                </button>
                              </div>
                              <div
                                style="
                                  position: absolute;
                                  top: 45px;
                                  right: 20px;
                                "
                              >
                                <color-picker
                                  v-model="hex_color"
                                  :width="100"
                                  :height="100"
                                  v-if="showColorPicker"
                                ></color-picker>
                              </div>
                            </div>

                            <div class="errors help-block">
                              <span>{{ errors[0] }}</span>
                            </div>
                          </div>
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- aca cierre row 1 -->

        <!-- DIV CONTIENE (TeamMate -  illustrative example - OliverList Bookers) -->
        <div class="row" v-if="!isBdrUser">
          <!-- Team Mate -->
          <div class="col-md-12 text-center mt-3" v-if="permissionFront()">
            <h6 class="font-weight-bold" v-if="dataUser.users.length > 0">
              {{ $t("lang.label.team") }}
            </h6>
            <div
              class="form-group text-center"
              v-if="dataUser.users.length > 0"
            >
              <label for="CurrentPassword" class="ml-4 col-form-label">{{
                $t("lang.label.teammates")
              }}</label>
              <div class="">
                <ul class="d-flex">
                  <li v-for="(usr, key) in dataUser.users" :key="key">
                    <div class="container-circle-users">
                      <div class="circle">
                        <span class="font-weight-bold">{{
                          (usr.name + usr.lastname) | firstLetters
                        }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Calendly -->
        <div class="row">
          <div class="col-md-6 mt-3" v-if="permissionFront() && !isBdrUser">
            <div class="title px-4 pb-2 pt-4">
              <div class="d-flex">
                <div>
                  <h4>Calendly</h4>
                </div>
              </div>
            </div>
            <div class="body p-4">
              <div class="form-group mt-2">
                <input
                  type="text"
                  class="form-control"
                  v-model="dataUser.user.calendly"
                />

                <a
                  href="https://calendly.com/integrations"
                  target="_blank"
                  class="text-primary"
                  >https://calendly.com/integrations</a
                >

                <div v-if="calendly" class="mt-2">
                  <div class="float-left mr-3">
                    <img
                      class=""
                      :src="calendly.avatar_url"
                      width="100px"
                      height="100px"
                    />
                  </div>
                  <div class="d-inline">
                    <strong class="d-block">{{ calendly.name }}</strong>
                    <span class="d-block">{{ calendly.email }}</span>
                    <span class="d-block">{{ calendly.timezone }}</span>
                    <span class="d-block"
                      ><a
                        class="text-primary"
                        target="_blank"
                        :href="calendly.scheduling_url"
                        >{{ calendly.scheduling_url }}</a
                      ></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--//GROUP-->
          <div v-if="false">
            <div
              class="col-md-6 mt-3"
              v-if="dataUser.user.team_role_id && permissionFront()"
            >
              <div class="title px-4 pb-2 pt-4">
                <div class="d-flex">
                  <div>
                    <h4>Group</h4>
                  </div>
                </div>
              </div>
              <div class="body p-4">
                <div class="form-group mt-2">
                  <ul>
                    <li v-for="team in myteam">
                      <strong class="mr-2">{{ team.name }}</strong>
                      <i :class="getRoleGroup(team.team_role_id)"></i>
                      {{ team.username }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!--//Card-->
          <div class="col-md-6 mt-3" v-if="false">
            <div class="title px-4 pb-2 pt-4">
              <div class="d-flex">
                <div>
                  <h4>Black List</h4>
                </div>
              </div>
            </div>
            <div class="body p-4">
              <div class="form-group mt-2">
                <button
                  @click="clickblacklist()"
                  class="btn-primary btn-sm"
                  v-if="!blacklist"
                >
                  <i class="icon-edit"></i> {{ $t("lang.label.edit") }}
                </button>

                <button
                  @click="saveblacklist()"
                  class="btn-primary btn-sm"
                  v-if="blacklist"
                >
                  <i class="icon-save"></i>{{ $t("lang.button.save") }}
                </button>

                <multiselect
                  :disabled="!blacklist"
                  v-model="domains_excluded"
                  v-bind:tag-placeholder="$t('lang.search.add')"
                  v-bind:placeholder="
                    $t('lang.label.enterthedomainstoexcludeseparatedbycommas')
                  "
                  label="domains_excluded"
                  track-by="id"
                  autocomplete="off"
                  :options="domains_excluded"
                  :multiple="true"
                  :taggable="true"
                  :searchable="true"
                  :showLabels="true"
                  openDirection="below"
                  class="small"
                  @remove="removeTag($event, domains_excluded)"
                  @tag="addTag($event, domains_excluded)"
                >
                  <template slot="tag" slot-scope="props">
                    <span class="mr-1 p-1 text-white rounded bg-primary">
                      <span v-text="props.option.domains_excluded"></span>
                      <i
                        @click="removeTag(props.option, domains_excluded)"
                        class="icon-close pl-1 cursor-pointer"
                      ></i>
                    </span>
                  </template>
                </multiselect>

                <small class="form-text text-muted">{{
                  $t("lang.label.enterthedomainstoexcludeseparatedbycommas")
                }}</small>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <!-- Button save + terms and conditions and contract booker -->
        <div class="my-4 text-center mr-3">
          <button class="ml-1 btn btn-success w-25 font-weight-bold rounded-pill" @click="SaveAll()">
            {{ $t("lang.button.save") }}
          </button>
          <div class="d-flex justify-content-center">
            <div class="col-md-4 text-center" v-if="hasPermissions('billing')">
              <button
                class="align-self-end btn btn-sm btn-theme-bg-transparent ml-2"
                :class="btnLoading ? 'btn-secondary btn-loading mt-1' : ''"
                @click="getContractClient"
              >
                {{ $t("lang.label.download") }}
                {{ $t("lang.label.terms_and_conditions")
                }}<i class="icon-download ml-2"></i>
              </button>
              <span class="loadingres spinner-border loading-spinner ml-2 text-white" v-if="btnLoading"></span>
              <div style="opacity: 0">
                <Modal :name="'pdf-modal'" @opened="onModalOpened">
                  <TermsAndConditionsProposalHtml :client="billingDataPayment" />
                </Modal>
              </div>
            </div>
            <div class="col-md-4 text-center" v-if="isBdrUser && user.booker.status != 'Screening'">
              <button
                class="align-self-end btn btn-sm btn-theme-bg-transparent ml-2 mt-2"
                :class="btnLoading ? 'btn-secondary btn-loading' : ''"
                @click="openModal('pdf-modal')"
              >
                <i class="icon-download ml-2"></i>
                {{ $t("lang.label.download") }}
                Contract Booker
              </button>
              <div style="opacity: 0;">
                <!-- 
                :name="'pdf-modal'" @opened="onModalOpened" :width="900" :height="700"
                Para modificar comodamente el modal, usando opacity 1 para que sea visible
                -->
                <Modal :name="'pdf-modal'" @opened="onModalOpened">
                  <ContractBookerHtml :booker="contractBooker" />
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions, mapMutations } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { usersService } from "@/_services";
import { bookersService } from "@/_services";
import ChangePassword from "@/components/Account/ChangePassword";
import $ from "jquery";
import imageUser from "@/assets/images/emptyperson.png";
import uploadImage from "vue-image-crop-upload";
import Tutorial from "@/components/Tutorial.vue";
import Multiselect from "vue-multiselect";
import { pdfTermsAndConditionsMixin } from "@/_mixins/";
import ColorPicker from "vue-color-picker-wheel";
import Treeselect from "@riophae/vue-treeselect";
import TermsAndConditionsHtml from "@/components/Account/TermsAndConditionsHtml.vue";
import TermsAndConditionsProposalHtml from "@/views/TermsAndConditionsProposalHtml.vue";
import ContractBookerHtml from "@/components/Account/ContractBookerHtml.vue";
import { clientsService } from '@/_services';
import moment from "moment";
Vue.component("multiselect", Multiselect);

export default {
  data() {
    return {
      colorRules: {
        required: true,
        "hex-color": true,
      },
      btnLoading: false,
      namePDF: 0,
      billingDataPayment: [],
      colorKey: 0,
      hex_color: "",
      customStyle: "",
      baeCustomStyle:
        "position:absolute;top:1px;right:1px;cursor:pointer;border-radius:3px;width:50px;height:36.5px;border-left:1px solid #ced4da;",
      showColorPicker: false,
      invalidInput: false,
      myteam: [],
      blacklist: false,
      calendly: false,
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      contractBooker: {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        date: "",
        nameBooker: "",
        bookerStatus: "",
      },
      dataUser: {
        user: {},
        client: {},
        users: {},
        domains_excluded: "",
      },
      domains_excluded: [],
      passwords: {
        currentPass: "",
        newPass: "",
        newPassValid: "",
      },
      loading: true,
      langs: [],
      spokenLangs: [],
      image: { url: require("@/assets/images/emptyperson.png") },
      show: false,
      params: {
        token: "123456798",
        name: "avatar",
      },
      headers: {
        smail: "*_~",
      },
      campos: [
        {
          nombre: "YourName",
          roles: [1, 2, 3],
        },
        {
          nombre: "YourLastName",
          roles: [1, 2, 3],
        },
        {
          nombre: "YourEmail",
          roles: [],
        },
        {
          nombre: "YourTtile",
          roles: [],
        },
        {
          nombre: "CompanyName",
          roles: [1, 2],
        },
        {
          nombre: "CompanyNameUsed",
          roles: [1, 2, 4],
        },
        {
          nombre: "CompanyEmail",
          roles: [1, 2],
        },
      ],
    };
  },

  watch: {
    "dataUser.user.name"() {
      this.dataUser.user.name = this.$sanitize(this.dataUser.user.name);
    },
    "dataUser.user.lastname"() {
      this.dataUser.user.lastname = this.$sanitize(this.dataUser.user.lastname);
    },
    "dataUser.user.email"() {
      this.dataUser.user.email = this.$sanitize(this.dataUser.user.email);
    },
    "dataUser.client.name"() {
      this.dataUser.client.name = this.$sanitize(this.dataUser.client.name);
    },
    "dataUser.client.email"() {
      this.dataUser.client.email = this.$sanitize(this.dataUser.client.email);
    },
    hex_color() {
      this.setColorPicker();
    },
  },
  mixins: [pdfTermsAndConditionsMixin],
  components: {
    LoadingSpinner,
    uploadImage,
    Tutorial,
    Multiselect,
    ChangePassword,
    ColorPicker,
    Treeselect,
    TermsAndConditionsHtml,
    TermsAndConditionsProposalHtml,
    ContractBookerHtml,
  },

  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      user: (state) => state.authentication.user,
      Languages: (state) => state.optionsList.all["languages"].data,
    }),

    toastNotificationData() {
      return this.$store.state.authentication.toastNotificationData;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    isBdrUser() {
      if (this.user.team_role_id == 2 && this.user.role_id == 2) {
        return true;
      } else {
        return false;
      }
    },
    isUserOperational() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 1;
    },
    isUserOliverSale() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 2;
    },
  },

  created() {
    this.getDataUs();
    if(this.user.role_id == 2) this.getContractData();
    this.$modal.show("pdf-modal");
    
    this.$store.dispatch("optionsList/getLanguages").then(() => {
        this.langs = this.Languages.filter((el, i) => i < 4);
        this.spokenLangs = this.Languages
          .filter((el, i) => i < 4)
          .map((el) => ({ id: el.id, label: el.name }));
    });
    if (this.permissionFront()) {
      this.getCalendly();
    }
    if (this.dataUser.user.team_role_id && this.permissionFront()) {
      this.myTeamList();
    }
  },

  methods: {
    getContractClient() {
      console.log("entro")
      this.btnLoading = true;
      clientsService
        .getContractClient()
        .then(({ blob, filename }) => {
          const downloadName = filename
            ? filename.endsWith(".pdf")
              ? filename
              : `${filename}.pdf`
            : `contract-${this.user.client_id}.pdf`;
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: "application/octet-stream" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.download = downloadName;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(() => window.URL.revokeObjectURL(url), 200);
          this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.btnLoading = false;
        });
    },
    openModal(modalId) {
      this.btnLoading = true;
      this.$modal.show(modalId);
    },
    onModalOpened() {
      if (this.isBdrUser) {
        this.downloadTermsAndConditionsPDF((this.namePDF = 1)).then(
          (result) => {
            this.btnLoading = false;
          }
        );
      } else {
        this.downloadTermsAndConditionsPDF((this.namePDF = 3))
        .then(() => {
          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        })
        .finally(() => {
          this.btnLoading = false;
          this.$modal.hide("pdf-modal");
        });
      }
    },
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    ...mapMutations("sidebar", {
      NavigationClicked: "navigationClicked",
    }),
    ...mapActions("onboarding", {
      setStatusOnboarding: "setStatusOnboarding",
    }),
    ...mapActions("authentication", {
      setAvatarUser: "setAvatarUser",
    }),
    openColorPicker() {
      if (this.showColorPicker) {
        this.showColorPicker = false;
      } else {
        this.showColorPicker = true;
      }
    },
    setColorPicker() {
      this.dataUser.client.hex_color = this.hex_color;
      this.customStyle =
        this.baeCustomStyle +
        "background-color:" +
        this.dataUser.client.hex_color;
    },
    clickblacklist() {
      this.blacklist = true;
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    getRoleGroup(role_id) {
      if (role_id == "1") {
        return "icon-group";
      }
      if (role_id == "2") {
        return "icon-user";
      }
      if (role_id == "3") {
        return "icon-eye";
      }
    },
    permissionFront() {
      return (
        this.user.team_role_id != undefined &&
        this.user.team_role_id != 3 &&
        this.user.role_id != 4
      );
    },
    calculatePercentage() {
      let left = this.toastNotificationData.credits.left;
      let attempts = this.toastNotificationData.credits.attempts;
      let total = this.toastNotificationData.credits.total;
      return Math.floor((attempts / total) * 100);
    },
    myTeamList() {
      usersService.getGroupList().then((result) => {
        this.myteam = result;
      });
    },

    getContractData() {
      bookersService.getConfigContract().then((response) => {
        if (response.status === 200) {
          const workingDays = response.result.working_hours_availability;

          const monday = workingDays.find((day) => day.id === 0);
          const tuesday = workingDays.find((day) => day.id === 1);
          const wednesday = workingDays.find((day) => day.id === 2);
          const thursday = workingDays.find((day) => day.id === 3);
          const friday = workingDays.find((day) => day.id === 4);

          this.contractBooker.Monday = monday ? monday.hours : [];
          this.contractBooker.Tuesday = tuesday ? tuesday.hours : [];
          this.contractBooker.Wednesday = wednesday ? wednesday.hours : [];
          this.contractBooker.Thursday = thursday ? thursday.hours : [];
          this.contractBooker.Friday = friday ? friday.hours : [];
          this.contractBooker.date = response.result.signed_on;
        }
      });
    },

    saveblacklist() {
      this.dataUser.client.update_blacklist = true;
      this.blacklist = false;
      this.saveData();
    },
    downloadImage() {},
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl, field) {
      this.dataUser.user.avatar = imgDataUrl;
    },
    cropUploadSuccess(jsonData, field) {},
    cropUploadFail(status, field) {},

    getDataUs() {
      this.loading = true;
      usersService.getUserSettings().then((result) => {
        this.dataUser = result;
        if(this.dataUser.paymentProfile && this.dataUser.paymentProfile != null){
          this.billingDataPayment = this.dataUser.paymentProfile;
        }
        const fullName = this.dataUser.user.name + " " + this.dataUser.user.lastname;
        this.contractBooker.nameBooker = fullName;
        if(this.user.booker && this.user.booker.status) this.contractBooker.bookerStatus = this.user.booker.status;
        if (this.isBdrUser && this.dataUser.user.bank_data) {
          if(this.dataUser.user.bank_data.account_holder_name == null || this.dataUser.user.bank_data.account_holder_name == ""){
            this.dataUser.user.bank_data.account_holder_name = fullName;
          }
        }
        if (
          this.dataUser.client !== null &&
          this.dataUser.client.domains_excluded != undefined &&
          this.dataUser.client.domains_excluded !== ""
        ) {
          var values = this.dataUser.client.domains_excluded;
          for (var i = 0; i < values.length; i++) {
            this.domains_excluded.push({ ["domains_excluded"]: values[i] });
          }
          this.dataUser.client.domains_excluded = this.getDomainsExcluded(
            this.domains_excluded
          );
        }

        if (
          this.dataUser.client != null &&
          (this.dataUser.client.hex_color === undefined ||
            this.dataUser.client.hex_color == "" ||
            this.dataUser.client.hex_color == null)
        ) {
          this.dataUser.client.hex_color = "#000000";
        }
        if (this.dataUser.client != undefined) {
          this.hex_color = this.dataUser.client.hex_color;
        }
        this.loading = false;
      });
    },

    rolCampo(campo) {
      for (let i = 0; i < this.campos.length; i++) {
        if (this.campos[i]["nombre"] == campo) {
          if (
            $.inArray(parseInt(this.user.role_id), this.campos[i]["roles"]) ==
            -1
          ) {
            return true;
          } else {
            return false;
          }
        }
      }

      return false;
    },

    validatePasswords() {
      return this.passwords.newPass === this.passwords.newPassValid;
    },

    checkFildsPass() {
      this.errorPass = [];
      if (!this.passwords.currentPass) {
        this.errorPass.push("The field Current Password can not be blank.");
        return false;
      }
      if (!this.passwords.newPass) {
        this.errorPass.push("The field New Password can not be blank.");
        return false;
      }
      if (!this.passwords.newPassValid) {
        this.errorPass.push("The field Confirm Password can not be blank.");
        return false;
      }
      if (
        !/^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,}).{6,16}$/.test(
          this.passwords.newPass
        )
      ) {
        this.errorPass.push(this.$t("lang.validation.password"));
        return false;
      }
      if (!this.validatePasswords()) {
        this.errorPass.push(
          "The filds New Password and Confirm Password are different."
        );
        return false;
      }
      if (!this.errorPass.length) {
        return true;
      }
    },
    saveData() {
      usersService
        .setUserSettings(
          this.dataUser.user,
          this.dataUser.client,
          this.dataUser.user.avatar
        )
        .then((result) => {
          this.dataUser.client.domains_excluded = this.getDomainsExcluded(
            this.domains_excluded
          );

          if (this.dataUser.user.avatar) {
            const item = {
              name: "avatar",
              value: true,
            };
            this.setAvatarUser(this.dataUser.user.avatar);
            this.setStatusOnboarding(item);
          }
        });
    },
    saveCalendly() {
      usersService.saveCalendly(this.dataUser.user.calendly).then((result) => {
        this.getCalendly();
      });
    },
    getCalendly() {
      usersService.getCalendly().then((result) => {
        this.calendly = result;
      });
    },
    validate() {
      let valid = this.checkFildsPass();
      if (valid) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.changepassword"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.value) {
            this.changePass();
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.passwordchangedsuccessfully"),
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }
    },
    changePass() {
      usersService.changePassword(
        this.passwords.currentPass,
        this.passwords.newPassValid
      );
    },
    formValidate() {
      if (this.$refs.colorPickerV != undefined) {
        this.$refs.colorPickerV.validate();
        if (this.$refs.colorPickerV.errors.length > 0) {
          return false;
        }

        //Valid company_name
        return true;
        const value = this.dataUser.client
          ? this.dataUser.client.company_name
          : "";

        if (value.trim().length === 0) {
          this.invalidInput = true;
          return false;
        }

        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const regexUrl =
          /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[^\s.]+\.[^\s]{2,}$/i;

        if (!regexEmail.test(value) && !regexUrl.test(value)) {
          this.invalidInput = false;
        } else {
          this.invalidInput = true;
          return false;
        }
        return true;
      }
    },
    SaveAll() {
      if (this.formValidate()) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.saveallchanges"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.value) {
            this.saveData();
            let langSelected = this.langs.find(
              (item) => item.id === this.dataUser.user.language_id
            );

            const { dispatch } = this.$store;
            dispatch("authentication/setLangCode", langSelected.lang_code).then(
              (result) => {
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  text: this.$t("lang.label.yourdatawassuccessfullychanged"),
                  showConfirmButton: false,
                  timer: 1500,
                });

                this.NavigationClicked();
              }
            );
            if (this.permissionFront()) {
              this.saveCalendly();
            }
          }
        });
        return false;
      }
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.checktheerrormessagesintheformandtryagain"),
        text: "",
        showCancelButton: false,
        confirmButtonText: "Ok",
      });
    },

    addTag(newTag, tagsany) {
      newTag = this.$sanitize(newTag);

      this.dataUser.client.domains_excluded = newTag;
      var newTags = newTag.split(",");

      newTags.forEach((newTag) => {
        const tag = {
          domains_excluded: newTag,
        };

        tagsany.push(tag);

        if (tagsany != undefined && tagsany.length > 0) {
          tagsany = tagsany.filter(
            (t) => t.domains_excluded != tag.domains_excluded
          );
          this.domains_excluded = tagsany;
        }
        this.domains_excluded.push(tag);
        this.dataUser.client.domains_excluded = this.getDomainsExcluded(
          this.domains_excluded
        );
      });
    },

    removeTag(tag, tagsany) {
      if (tagsany != undefined && tagsany.length > 0) {
        tagsany = tagsany.filter(
          (t) => t.domains_excluded != tag.domains_excluded
        );
        this.domains_excluded = tagsany;
      }
      this.domains_excluded = tagsany;
      this.dataUser.client.domains_excluded = this.getDomainsExcluded(
        this.domains_excluded
      );
    },

    getDomainsExcluded(arrayObjects) {
      return Array.prototype.map
        .call(arrayObjects, function (item) {
          return item.domains_excluded;
        })
        .join(",");
    },
  },
};
</script>
